import { render, staticRenderFns } from "./jihe.vue?vue&type=template&id=17026463&"
import script from "./jihe.vue?vue&type=script&lang=ts&"
export * from "./jihe.vue?vue&type=script&lang=ts&"
import style0 from "./jihe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports